import { getFormattedDateTime } from '@lmt/unicorn-shared/app/components/patients/common';
import { RPDF } from './common/react-pdf';
import React from 'react';

export const ReportPagination: React.FC = () => {
  return (
    <RPDF.View fixed style={RPDF.styles.paginationContainer}>
      <RPDF.View fixed style={RPDF.styles.paginationDataContainer}>
        <RPDF.View style={RPDF.styles.paginationPages}>
          <RPDF.Text
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
            style={RPDF.styles.paginationText}
          />
        </RPDF.View>
        <RPDF.View style={RPDF.styles.paginationDate}>
          <RPDF.Text style={RPDF.styles.paginationText}>
            {getFormattedDateTime(new Date())}
          </RPDF.Text>
        </RPDF.View>
      </RPDF.View>
    </RPDF.View>
  );
};
